import { render } from "./ImportTargets.vue?vue&type=template&id=55b72e7a"
import script from "./ImportTargets.vue?vue&type=script&lang=js"
export * from "./ImportTargets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__